import * as React from 'react'
import { InjectedFormProps, reduxForm, Field } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { forgotPassword } from './forgotPassword.reducer'
import { RouteComponentProps } from 'react-router'

import { translate } from '../../i18n'
import { Link } from 'react-router-dom'
import { IAppState } from '../../store/state.interface.web'
import { required, isValidEmail } from '../../../Web/common/validate'
import { FormField } from '../../../Web/components/FormField/FormField'
import LogoHeader from '../logoHeader'

// todo: saga success&data from api
// todo:remove inline styles

const ForgotPasswordForm: React.FC<
  InjectedFormProps<{}, RouteComponentProps> & RouteComponentProps
> = props => {
  const { handleSubmit } = props
  const dispatch = useDispatch()
  const loading = useSelector<IAppState, boolean>((state: IAppState) => state.forgotPassword.loading)

  const submitForgotPassword = (submittedValues: any) => {
    dispatch(forgotPassword(submittedValues))
  }

  const renderLoader = () => {
    if (loading) {
      return <em className="fas fa-circle-notch fa-spin ml-1" />
    }
  }

  return (
    <>
      <div className="block-center wd-xxxl d-flex flex-column full-height justify-content-center">
        <div className="card card-flat">
        <LogoHeader/>
          <div className="card-body">
            <p className="text-center auth-title">
              {translate('forgotPassword.title')}
            </p>
            <form className="w-75 m-auto" onSubmit={handleSubmit(submitForgotPassword)}>
              <p className="text-center">
                {translate('forgotPassword.subtitle')}
              </p>
              <Field
                name="email"
                component={FormField}
                type="email"
                required
                label={''}
                placeholder={translate('forgotPassword.emailPlaceholder')}
                validate={[required, isValidEmail]}
                icon="fa-envelope"
              />
              <div className="clearfix">
                <div className="float-right mb-3">
                  <Link to="/login" className="text-muted">
                    <span className="auth-subLinks">
                      {translate('forgotPassword.login')}
                    </span>
                  </Link>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-block"
              >
                {translate('forgotPassword.submitButtonLabel')} {renderLoader()}
              </button>
            </form>
          </div>
        </div>
        <div className="p-3 text-center">
          <span className="mr-2">&copy;</span>
          <span>{translate('authLayout.copyRights')}</span>
          <span className="mx-2"></span>
          <br />
          <span>{`Remote Patient Monitoring`}</span>
          <br />
          <span>{translate('authLayout.rightsReserved')}</span>
        </div>
      </div>
    </>
  )
}

export default reduxForm<{}, RouteComponentProps>({
  form: 'ForgotPasswordForm'
})(ForgotPasswordForm)
